import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';

import { AlertService, GrowlType } from './alert.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Translator } from 'angular-translator';
import { BADFLAGS } from 'dns';
import { AzureFile } from '../model/interfaces/azureFile.Interface';
import { InbrokerSuscripcion, Suscripcion, SmartixHubMxSubscription, SmartixHubArgSubscription, InsurerData, SubProductoInbroker, PlanInbroker, SuscripcionControls } from '../model/interfaces/suscripcion.interface';

export interface AtributoMetadata {
  columnaEnlaceDB: string;
  esColumna: boolean;
  esFiltro: boolean;
  esOrdenable: boolean;
  esVisible: boolean;
  extraInfo: string;
  position: number;
  tablaEnlaceDB: string;
  tipoFiltro: string;
}

export interface SubscriptionAttribute {
  subscriptionCode: string;
  systemCode: string;
  attributeCode: string;
  originalAttributeCode: string;
  type: string;
  source: string;
  state: string;
  scope: string;
  defaultValue: string;
  isOptional: boolean;
  metadata: string;
  description: string;
  productMapping: string;
  parsedMetadata: AtributoMetadata;
}

@Injectable()
export class SuscripcionesService {
  private url = 'api/suscripcion';
  private urlEx = 'api/suscripcion/excel';
  private urlSmartixHubMx = 'api/suscripcion/smartixhubmx';
  private urlSmartixHubArg = 'api/suscripcion/smartixhubarg';
  private urlRl = 'api/suscripcion/Rules';

  constructor(
    private sxHttp: SxHttpService,
    private alertService: AlertService,
    private translate: Translator
  ) { }

  guardarInbroker(suscripcion: InbrokerSuscripcion) {
    return this.sxHttp
      .post(this.url + '/inbroker', suscripcion)
      .toPromise()
      .then(response => response.json().data as InbrokerSuscripcion);
  }

  getRuleFiles(
    systemCode: string,
    idSuscription: string
  ): Observable<AzureFile[]> {
    const getUrl =
      this.url + `/GetAzureRuleFiles/${systemCode}/${idSuscription}`;
    return this.sxHttp.get(getUrl).map(response => {
      return response.json().data as AzureFile[];
    });
  }

  guardarConExcel(suscripcion: Suscripcion) {
    return this.sxHttp
      .post(this.urlEx, suscripcion)
      .toPromise()
      .then(response => response.json().data as Suscripcion);
  }

  //InBroker
  getInbrokerSuscripcion(
    idSuscripcion: string,
    systemCode: string
  ): Promise<InbrokerSuscripcion> {
    return this.sxHttp
      .get(`${this.url}/${idSuscripcion}/${systemCode}`)
      .toPromise()
      .then(result => result.json().data as InbrokerSuscripcion);
  }

  //Excel
  getSuscripcionConExcel(
    idSuscripcion: string,
    systemCode: string
  ): Promise<Suscripcion> {
    return this.sxHttp
      .get(`${this.urlEx}/Edit/${idSuscripcion}/${systemCode}`)
      .toPromise()
      .then(result => result.json().data as Suscripcion);
  }

  //Smartix Hub Mexico
  getSmartixHubMxSubscription(idSuscripcion: string, systemCode: string): Promise<SmartixHubMxSubscription> {
    return this.sxHttp
      .get(`${this.urlSmartixHubMx}/${idSuscripcion}/${systemCode}`)
      .toPromise()
      .then(result => result.json().data as SmartixHubMxSubscription);
  }

  saveSmartixHubMxSubscription(suscripcion: SmartixHubMxSubscription) {
    return this.sxHttp
      .post(this.urlSmartixHubMx, suscripcion)
      .toPromise()
      .then(response => response.json().data as Suscripcion);
  }

  //Smartix Hub Argentina
  getSmartixHubArgSubscription(idSuscripcion: string, systemCode: string): Promise<SmartixHubArgSubscription> {
    return this.sxHttp
      .get(`${this.urlSmartixHubArg}/${idSuscripcion}/${systemCode}`)
      .toPromise()
      .then(result => result.json().data as SmartixHubArgSubscription);
  }

  saveSmartixHubArgSubscription(suscripcion: SmartixHubArgSubscription) {
    return this.sxHttp
      .post(this.urlSmartixHubArg, suscripcion)
      .toPromise()
      .then(response => response.json().data as Suscripcion);
  }

  getInsusrers(systemCode: string, provider: string): Promise<InsurerData[]> {
    const url = `${
      environment.apiSmartix
      }api/provider/getInsusrers/${systemCode}/${provider}`;
    return this.sxHttp
      .getFromAbsolute(url)
      .toPromise()
      .then(response => {
        const list = response.json().Data as Object;
        let ret: InsurerData[] = [];
        (list['$values'] as any[]).forEach(element => {
          const el: InsurerData = {
            insurerId: element['InsurerId'],
            insurerDescription: element['InsurerDescription']
          };
          ret.push(el);
        });
        return ret;
      });
  }

  getProducts(
    systemCode: string,
    provider: string,
    idInsurer: number,
    nroTipoBien: number
  ): Promise<SubProductoInbroker[]> {
    const url = `${
      environment.apiSmartix
      }api/provider/getProducts/${systemCode}/${provider}/${idInsurer}/${nroTipoBien}`;
    return this.sxHttp
      .getFromAbsolute(url)
      .toPromise()
      .then(response => {
        const list = response.json().Data as Object;
        let ret: SubProductoInbroker[] = [];
        list['$values'].forEach(element => {
          let subplans: PlanInbroker[] = [];
          element['Plans']['$values'].forEach(pl => {
            const plib: PlanInbroker = {
              planCode: pl['PlanCode'],
              planDescription: pl['PlanDescription']
            };
            subplans.push(plib);
          });
          const el: SubProductoInbroker = {
            productCode: element['ProductCode'],
            productDescription: element['ProductDescription'],
            sectionCode: element['SectionCode'],
            sectionDescripction: element['SectionDescripction'],
            plans: subplans
          };
          ret.push(el);
        });
        return ret;
      });
  }

  saveRules(controlsToPost: any) {
    return this.sxHttp
      .post(this.urlRl, controlsToPost)
      .toPromise()
      .then(success => {
        this.alertService.showGrowl({
          type: GrowlType.SUCCESS,
          body: 'EDITADO_CORRECTAMENTE'
        });
      })
      .catch(reason => {
        this.alertService.showGrowl({
          type: GrowlType.DANGER,
          body: 'SOC_FE_0001_ERROR'
        });
      });
  }

  getRules(
    idSuscripcion: string,
    systemCode: string
  ): Promise<SuscripcionControls> {
    return this.sxHttp
      .get(`${this.urlRl}/Edit/${idSuscripcion}/${systemCode}`)
      .toPromise()
      .then(result => {
        const rules = JSON.parse(result.json().data);

        if (rules !== null) {
          const keys = Object.keys(rules);
          for (let j = 0; j < keys.length; j++) {
            const newKey = this.refactorPropertyName(rules, keys[j]);

            if (newKey === 'header') {
              const headers = rules[newKey];
              const keysHeader = Object.keys(headers);
              for (let i = 0; i < keysHeader.length; i++) {
                this.refactorPropertyName(headers, keysHeader[i]);
              }
            }
          }
        }

        return rules as SuscripcionControls;
      });
  }

  private refactorPropertyName(object, propertyName) {
    let newPropertyName = null;
    const firstCharacter = propertyName.charAt(0);
    if (firstCharacter !== firstCharacter.toLowerCase()) {
      newPropertyName = firstCharacter.toLowerCase() + propertyName.slice(1);
      object[newPropertyName] = object[propertyName];
      delete object[propertyName];
    } else {
      newPropertyName = propertyName;
    }

    return newPropertyName;
  }

  getSubscriptionForm(
    idSuscripcion: string,
    systemCode: string
  ): Observable<SubscriptionAttribute[]> {
    return this.sxHttp
      .get(this.url + '/Attributes/GetAll/' + idSuscripcion + '/' + systemCode)
      .map(result => result.json().data as SubscriptionAttribute[]);
  }

  getSingleAttribute(
    idSuscripcion: string,
    systemCode: string,
    codAttribute: string
  ): Observable<SubscriptionAttribute> {
    return this.sxHttp
      .get(
        this.url +
        '/Attributes/GetSingle/' +
        idSuscripcion +
        '/' +
        systemCode +
        '/' +
        codAttribute
      )
      .map(result => result.json().data as SubscriptionAttribute);
  }

  updateSubscriptionAttribute(
    atributo: SubscriptionAttribute
  ): Promise<SubscriptionAttribute> {
    const url = this.url + '/UpdateSubscriptionAttribute';

    return this.sxHttp
      .post(url, atributo)
      .toPromise()
      .then(response => response.json().data as SubscriptionAttribute);
  }

  deleteAttribute(
    codSubscription: string,
    systemCode: string,
    AttributeCode: string
  ): Promise<any> {
    const url = `${
      this.url
      }/DeleteAttribute/${codSubscription}/${systemCode}/${AttributeCode}`;
    return this.sxHttp
      .delete(url)
      .toPromise()
      .then(response => response.json().data as any);
  }

  ///Comprare new subscription attributes with actuals and generate excel file
  comparationAttributesResult(
    systemCode: string,
    subscriptionCode: string,
    controlsToPost: any
  ) {
    const url = `${
      this.url
      }/ComparationResult/${subscriptionCode}/${systemCode}`;
    return this.sxHttp
      .post(url, controlsToPost)
      .map(response => response.json().data as any)
      .toPromise();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/suscripciones.service.ts